<script lang="ts" setup>
import type { Product, FlashLink } from '~~/server/api/menu/footer'

export interface FooterLinksProps {
    links: Product[] | FlashLink[]
    linkBaseUrl?: string
}

const props = defineProps<FooterLinksProps>()

const getLink = (link: Product | FlashLink): VNuxtLinkTo => {
    if ('meta_product' in link && link['meta_product']) {
        return {
            name: link.slug,
        }
    }

    if ('isExternal' in link && link['isExternal']) {
        return link.slug
    }

    return `/${props.linkBaseUrl || ''}${link.slug}`
}
</script>
<template>
  <ul>
    <li
      v-for="(link, index) in props.links"
      :key="link.slug"
      :class="{ 'mb-2': index < props.links.length - 1 }"
    >
      <VNuxtLink
        class="fs-small text-black"
        :to="getLink(link)"
        :label="link.title"
        :target="link.isExternal ? '_blank' : '_self'"
      >
        {{ link.title }}
      </VNuxtLink>
    </li>
  </ul>
</template>
